<template>
  <div class="dashboard-rentabilidad-socios">
    <p>Sueldos de Socios - {{ anio }}</p>
    <!-- <p class="description">{{ descripcion }}</p> -->
      <b-table hover
          responsive="sm" 
          class="registro"
          :busy="tableBusy"
          :items="items" 
          :fields="fields"
          :current-page="paginaActual"
          :per-page="registrosPorPagina">
        <div slot="table-busy" class="text-center">
          <b-spinner class="table-spinner" label="Spinning" />
        </div>
        <template v-slot:cell(periodo)="data">
          {{ data.item.periodo | periodo }}
        </template>
        <template v-slot:cell(importe)="data">
          {{ data.item.importe | moneda }}
        </template>
    </b-table>
    <nav>
      <b-pagination size="sm" 
        :total-rows="totalRegistros" 
        :per-page="registrosPorPagina" 
        v-model="paginaActual" 
        prev-text="Prev." next-text="Prox."/>
    </nav>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: []
    },
    anio: {
      type: String,
      default: ''
    },
    totalRegistros: {
      type: Number,
      default: 0
    },
    paginaActual: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      key: 0,

      fields: [
        { key: 'personal' },
        { key: 'periodo' },
        { key: 'importe' },
      ],

      tableBusy: false,
      registrosPorPagina: 5,
    }
  },
  watch: {
    'items' : function(newVal, oldVal) {
      if ( newVal != oldVal ) {
        this.key++;
      }
    },    
  }    
}
</script>

<style>
  .dashboard-rentabilidad-socios {
    margin-bottom: 30px;
  }
  .dashboard-rentabilidad-socios p {
    font-size: 0.8em;
    font-weight: 700;
    margin-bottom: 20px;
  }

</style>


